module.exports = __webpack_public_path__ + "static/temtum-1fb06881f25ec88e27e289ff895a4b8f.mp4";